



















































































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import { v4 as uuidv4 } from "uuid";
import { find } from "lodash";
import { configurePacksOnDurationChanged } from "@/optimizedEncoding/scripts/packConfig";
import { resetPayment } from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },
    props: {
        hideBillboard: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            pathInStore: "transaction.duration",
            pathTransactionPackagesInStore: "transaction.packages",
            selectedPackageInStore: "publication.visualizationOption",
            specificId: uuidv4() as string,
            configuredPacksInStore: "transaction.configuredPacks",
            showTooltip: false,
            tooltipAutoShown: false,
            iconTopPx: null as number | null,
            resizeObserver: null as ResizeObserver | null,
        };
    },
    computed: {
        extensionOption: function(): any | null {
            return this.$store.state.OrdersModule.currentOrder.extensionOption || null; 
        },
        selectedPricing: function(): any {
            return this.$store.getters["FormModule/getValueTransaction"]("transaction.selectedPricing");
        },
        pricingPack: function(): string|null {
            if(this.$store.getters["FormModule/getValueTransaction"](this.pathInStore)) {
                return this.$store.getters["FormModule/getValueTransaction"](this.pathInStore);
            } 
            return null;
        },
        transactionType: function(): string {
            return this.getTransactionType();
        },
        isDisplayed: function(): boolean {
            return true; // TODO: Refactor with correct value
        },
        options: function(): Array<Record<string, unknown>> {
            const packages = this.$store.getters["FormModule/getValueTransaction"](this.pathTransactionPackagesInStore);
            const optionsArray = [];
            if (packages) {
                for(let pack of packages) {
                    optionsArray.push({
                        "label": `${this.pluralization(`x_${pack.duration.unit.toLowerCase()}s`, pack.duration.count)}`,
                        "value": pack.id
                    });
                }
            }
            return optionsArray;
        }
    },
    watch: {
        options: {
            immediate: true,
            handler: function(newValue: Array<Record<string, unknown>>): void {
                if (!newValue || !newValue.length) {
                    return;
                }
                if (!this.tooltipAutoShown) {
                    this.tooltipAutoShown = true;
                    setTimeout(() => {
                        this.showTooltip = true;
                    }, 500);
                }
                this.$nextTick(() => {
                    this.observeSelectSize();
                });
            }
        }
    },
    beforeDestroy: function(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    mounted: function() {
        if (this.isDisplayed && this.$store.getters["FormModule/getValueTransaction"](this.pathInStore) == null) {
            this.$store.commit("FormModule/addValueTransaction", {path: this.pathInStore, value: ""});
        }
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        syncIconPosition: function(): void {
            const selectEl = document.getElementById("pricingPack");
            const fieldEl = this.$el as HTMLElement;
            if (!selectEl || !fieldEl) {
                return;
            }
            const selectRect = selectEl.getBoundingClientRect();
            const fieldRect = fieldEl.getBoundingClientRect();
            const iconHeight = 24;
            this.iconTopPx = (selectRect.top - fieldRect.top) + (selectRect.height - iconHeight) / 2;
        },
        observeSelectSize: function(): void {
            const selectEl = document.getElementById("pricingPack");
            if (!selectEl || this.resizeObserver) {
                return;
            }
            this.syncIconPosition();
            if (typeof ResizeObserver === "undefined") {
                return;
            }
            this.resizeObserver = new ResizeObserver(() => {
                this.syncIconPosition();
            });
            this.resizeObserver.observe(selectEl);
            this.resizeObserver.observe(this.$el as Element);
        },
        updateSelectedPackOptionsWithNewPrices: function(pricingMonthsChosen: any): void {
            const currentSelectedOptions = this.$store.getters["FormModule/getValueTransaction"](
                "optimizedEncoding.selectedPackOptions"
            ) || {};

            const selectedPackKey = this.$store.getters["FormModule/getValueTransaction"](this.selectedPackageInStore);
            
            if (!selectedPackKey || !currentSelectedOptions[selectedPackKey]) {
                return;
            }

            const packOptions = currentSelectedOptions[selectedPackKey];
            const updatedPackOptions = { ...packOptions };

            updatedPackOptions.extension = 0;

            ["basic", "classic", "premium"].forEach(key => {
                if (currentSelectedOptions[key]) {
                    currentSelectedOptions[key].extension = 0;
                }
            });

            // Update billboard option with new price
            if (packOptions.billboard && pricingMonthsChosen.billboard) {
                const billboardPriceProperty = `${selectedPackKey}Price`;
                const newBillboardPrice = pricingMonthsChosen.billboard[billboardPriceProperty];
                
                if (newBillboardPrice !== undefined) {
                    updatedPackOptions.billboard = {
                        price: newBillboardPrice
                    };
                }
            }

            // Commit the updated selected pack options
            this.$store.commit("FormModule/addValueTransaction", {
                path: "optimizedEncoding.selectedPackOptions",
                value: {
                    ...currentSelectedOptions,
                    [selectedPackKey]: updatedPackOptions
                }
            });
        },
        updateValue: function(durationId: number): void {
            resetPayment();
            const selectedPricing = find(
                this.$store.getters["FormModule/getValueTransaction"](this.pathTransactionPackagesInStore),
                { id: durationId }
            );

            if (!selectedPricing) return;

            this.$store.commit("FormModule/addValueTransaction", {
                path: "transaction.selectedPricing",
                value: selectedPricing
            });

            const configuredPacks = configurePacksOnDurationChanged(
                selectedPricing,
                this.transactionType,
                { hideBillboard: this.hideBillboard }
            );

            this.$store.commit("FormModule/addValueTransaction", {
                path: this.configuredPacksInStore,
                value: configuredPacks
            });
            
            this.$store.commit("FormModule/addValueTransaction", {path: "transaction.discountCode", value: false});
            this.$store.commit("FormModule/addValueTransaction", {"path": this.pathInStore, "value": durationId});
            const pricingMonthsChosen = find(this.$store.getters["FormModule/getValueTransaction"]("transaction.packages"), {"id": durationId});

            if(pricingMonthsChosen) {
                this.$store.commit("FormModule/addValueTransaction", {"path": "transaction.pricing.basic", "value": pricingMonthsChosen.visualizationOptions.basic});
                this.$store.commit("FormModule/addValueTransaction", {"path": "transaction.pricing.classic", "value": pricingMonthsChosen.visualizationOptions.classic});
                this.$store.commit("FormModule/addValueTransaction", {"path": "transaction.pricing.premium", "value": pricingMonthsChosen.visualizationOptions.premium});
                this.$store.commit("FormModule/addValueTransaction", {"path": "transaction.pricing.extensionOptionDetails", "value": pricingMonthsChosen.extensionOption});
                this.$store.commit("FormModule/addValueTransaction", {"path": "transaction.pricing.extensionOption", value: null});
                this.$store.commit("FormModule/addValueUI", {"path": "transaction.pack", "value": pricingMonthsChosen});
                this.$store.commit("OrdersModule/setExtensionOption",pricingMonthsChosen.extensionOption);

                // Update selectedPackOptions with new prices for currently selected options
                this.updateSelectedPackOptionsWithNewPrices(pricingMonthsChosen);
            }
        }
    },
});
